<template>
  <div class="box" v-if="open"  :class="!store.state.isPc ? 'boxPc' : ''">
    <!-- v-if="open" -->
     <div class="imgBox" @click.stop="open = true">     <img :src="getImagePath(imgString)" alt=""></div>
        <div class="closeBox"  @click.stop="open = false"><img src="@/assets/images/close.png" alt=""></div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import images from "@/utils/images.ts";
import { useStore } from "vuex";
const store = useStore();
var { getImagePath } = images;
const open = ref(false)
const imgString = ref('')
const openString = (string)=>{
    console.log(string);
    imgString.value = string;
    open.value = true;
}
// eslint-disable-next-line no-undef
defineExpose({
    openString
});
</script>

<style lang="scss">
.box{
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    bottom: 0;
    background-color: #00000090;
    z-index: 99;
    display: flex;
    padding-top: 10%;
    flex-direction: column;
    align-items: center;

    &.boxPc{
        padding-top: 40%;
    }

    .imgBox{
        // width: 80%;
        max-width: 40rem;
        margin: 0 auto;
        img{
            width: 100%;
        }
    }
    .closeBox{
        width: 4rem;
        height: 4rem;
        margin-top: 2rem;
        border-radius: 50%;
        img{
            width: 100%;
            height: 100%;
        }
    }
}
</style>
